import React from 'react';
import { compose } from 'ramda';
import connect from 'react-redux/es/connect/connect.js';
import PropertyManager from '@synergycms_core/components/HoC/propertyManager';
import { withThemeJSS } from '@synergycms_core/components/providers/themeProvider';
import styleFile from './AvailServiceRoomTab.js';
import RichText from '@synergycms_core/components/generic/RichText';
import { roomCanAddService, boardCanAddService } from '../../../store/avail/availUtils.js';
import { List } from 'immutable';
import { Image } from '@synergycms_core/components/generic/';

import classnames from 'classnames/bind';

const mapStateToProps = (store, ownProps) => {
  const hotelId = store.getIn(['customer', 'current_hotel']);
  return {
    params : store.getIn(['customer', 'params']),
    staticRooms: store.getIn(['hotels', hotelId, 'rooms'], List())
  };
};

export default compose(
  connect(
    mapStateToProps
  ),
  PropertyManager([
    "block",
    "service",
    "serviceBlocks",
    "changeBlockService",
    "currentRoom",
    "params",
    "selectedBlock",
    "setSelectedBlock",
    "staticRooms"
  ]),
  withThemeJSS({ styleFile, link: true })
)(class AvailServiceRoomTab extends React.Component {
  static displayName = 'AvailServiceRoomTab';

  constructor(props) {
    super(props);
    this.cx = classnames.bind(props.theme.styles.classes);

    this.state = {
    };
  }

  isMobile = () => this.props.theme.deviceType !== 'DESK';

  render() {
    const { theme, config } = this.props;

    const {
      block,
      service,
      selectedBlock,
      setSelectedBlock,
      staticRooms
    } = config;

    const { classes } = theme.styles;

    if (!roomCanAddService(service)(block) || !boardCanAddService(service)(block)) {
      return false;
    }

    const idx = block.get('idx');
    const bookedService = block.get('services').find(s => s.get('service_id') === service.get('id')) || false;
    const roomName = staticRooms.find(room => room.get('id') === block.get('room_id')).get('name', '');

    return (
      <div key={idx} className={classes.roomDetailWrapper}>
        <div className={classes.roomDetailLine} onClick={setSelectedBlock(idx)}>
          <div className={classes.roomDetail}>
            <span className={[classes.roomDetailText, selectedBlock && classes.roomSelected].join(' ')}>
              <RichText text={'_%habitación%_'} innerStyle={['roboto13Black', 'capitalize']} translate={true} />
              <RichText text={' ' + idx} innerStyle={['roboto13Black']} />
            </span>
            {!!bookedService && <Image unicodeContent={'e0a9'} innerStyle={[classes.roomDetailCheck]} />}
          </div>
          {!this.isMobile() &&
            <div>
              <RichText text={roomName} innerStyle={['roboto13SoftGray',classes.roomsName]} />
            </div>
          }
        </div>
      </div>
    );
  }
});
